import { React, useState } from "react";
import Bloglist from "../components/Bloglist";
export default function Blog() {
    const [inputText, setInputText] = useState("");
    let inputHandler = (e) => {
        var lowerCase = e.target.value.toLowerCase();
        setInputText(lowerCase);
    };
    return (
        <div className="main-container">
            <div className="posts-header">
                <div className="post-content">
                    <h1>
                        Blog
                        <br></br>
                        Programmeren
                    </h1>
                    <div className="purple-line"></div>

                    <p>Bekijk hier onze blog</p>
                </div>
                <img
                    src="./img/project.svg"
                    alt="Grafische element van portfolio"
                />
            </div>
            <div className="search">
                <input
                    type="text"
                    onChange={inputHandler}
                    fullWidth
                    label="Search"
                    className="search-bar"
                    placeholder="Search.."
                />
            </div>
            <Bloglist input={inputText} />
        </div>
    );
}
